export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const API_KEY = '50a3f7a3-0021-438b-b395-df98696bfef1';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;
